import styled from "styled-components";
import { COLORS } from "../../../../../../../assets/constants/styles";

export const AnswerContainer = styled.div`
  background-color: ${COLORS.white};
  border: 2px solid ${COLORS.violet};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
`;

export const SourcesContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;

  strong {
    display: block;
    margin-bottom: 8px;
    font-size: 15px;
    color: ${COLORS.black};
  }
`;
